import React from 'react';
import {useFormContext} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

import {Button} from '@edna/components';
import {Icon} from '@edna/components/primitives';
import CleanFiltersIcon from '@edna/icons/cleanFilters.svg';
import FilterIcon from '@edna/icons/filter.svg';

import * as S from './style';

type TFiltersButton = {
  activeFiltersCount?: number;
  onToggleFilters?: TEmptyFunction;
};

const FiltersButton = React.memo<TFiltersButton>(({onToggleFilters, activeFiltersCount}) => {
  const {t} = useTranslation();

  return (
    <S.FilterButton
      appearance="secondary"
      block
      data-selector="Filter:filters"
      onClick={onToggleFilters}
    >
      <Icon as={FilterIcon} />
      {t('Filters:filters')}
      {!!activeFiltersCount && <S.FiltersCount>{activeFiltersCount}</S.FiltersCount>}
    </S.FilterButton>
  );
});

FiltersButton.displayName = 'FiltersButton';

type TCleanButtonProps = {
  name: string;
  value: string | TAnyObject | null;
};

const CleanFilterButton = React.memo<TCleanButtonProps>(({name, value}) => {
  const {setValue} = useFormContext();

  const handleClick = () => {
    setValue(name, value);
  };

  return (
    <Button square onClick={handleClick} size="XXS">
      <Icon as={CleanFiltersIcon} />
    </Button>
  );
});

CleanFilterButton.displayName = 'CleanFilterButton';

export {CleanFilterButton, FiltersButton};
